import { Component } from '@angular/core';
import { BaseEdit } from '../base-edit';
import { ReactiveFormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';
import { MatPrefix } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'ldw-check-edit',
  templateUrl: './check-edit.component.html',
  styleUrls: ['./check-edit.component.css'],
  imports: [ReactiveFormsModule, MatIcon, MatPrefix, MatTooltip, MatCheckbox]
})
export class CheckEditComponent extends BaseEdit {}
